import React from "react";
import { Grid, LinearProgress, Typography } from "@mui/material";
import { UploadType } from "../../../../../static/enums/UploadType";
import { getCachedUploadFilesUi } from "../../../../../mobx/ui/UploadFilesUi";
import { observer } from "mobx-react-lite";

interface UploadProgressProps {
  type: UploadType;
}

export default observer(function UploadProgress({ type }: UploadProgressProps) {
  const { loadProcess, isLoading } = getCachedUploadFilesUi(type);

  return isLoading ? (
    <Grid item container alignItems={"center"} spacing={1}>
      <Grid item sx={{ flexGrow: 1 }}>
        <LinearProgress variant={"determinate"} value={loadProcess} />
      </Grid>
      <Grid item>
        <Typography variant="body2" color="textSecondary">{`${loadProcess}%`}</Typography>
      </Grid>
    </Grid>
  ) : null;
});
